import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-dropdown"
    }}>{`sp-dropdown`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders a dropdown with menu items. The dropdown must contain a `}<a parentName="p" {...{
        "href": "/photoshop/uxp/2022/uxp-api/reference-spectrum/User%20Interface/sp-menu/"
      }}>{`sp-menu`}</a>{` with `}<inlineCode parentName="p">{`slot="options"`}</inlineCode>{`, and inside the `}<inlineCode parentName="p">{`sp-menu`}</inlineCode>{`, a series of `}<inlineCode parentName="p">{`sp-menu-item`}</inlineCode>{` or `}<inlineCode parentName="p">{`sp-menu-divider`}</inlineCode>{` elements.`}</p>
    <p><img alt="Dropdowns" src={require("../../assets/sp-dropdown.png")} /></p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/picker/"
        }}>{`https://spectrum.adobe.com/page/picker/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/components/dropdown"
        }}>{`https://opensource.adobe.com/spectrum-web-components/components/dropdown`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-dropdown placeholder="Make a selection..." style="width: 320px">
    <sp-menu slot="options">
        <sp-menu-item> Deselect </sp-menu-item>
        <sp-menu-item> Select inverse </sp-menu-item>
        <sp-menu-item> Feather... </sp-menu-item>
        <sp-menu-item> Select and mask... </sp-menu-item>
        <sp-menu-divider></sp-menu-divider>
        <sp-menu-item> Save selection </sp-menu-item>
        <sp-menu-item disabled> Make work path </sp-menu-item>
    </sp-menu>
</sp-dropdown>
`}</code></pre>
    <h2 {...{
      "id": "variations"
    }}>{`Variations`}</h2>
    <p>{`Dropdowns come in several different variations.`}</p>
    <h3 {...{
      "id": "quiet"
    }}>{`Quiet`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-dropdown quiet>...</sp-dropdown>
`}</code></pre>
    <h3 {...{
      "id": "disabled"
    }}>{`Disabled`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-dropdown disabled>...</sp-dropdown>
`}</code></pre>
    <h3 {...{
      "id": "invalid"
    }}>{`Invalid`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-dropdown invalid>...</sp-dropdown>
`}</code></pre>
    <h2 {...{
      "id": "responding-to-events"
    }}>{`Responding to events`}</h2>
    <p>{`You can respond to changes in the dropdown using the `}<inlineCode parentName="p">{`change`}</inlineCode>{` event.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`document.querySelector(".yourDropdown").addEventListener("change", evt => {
    console.log(\`Selected item: \${evt.target.selectedIndex}\`);
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      